import React, { Component, Fragment } from 'react';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import _ from 'lodash';

import ReactTableWrapper from 'Common/ReactTableWrapper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { caseInsensitiveFilter, dateSortMethod } from 'Common/GridHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import * as RIAStateCacheSelectors from 'State/pagestatecache/pages/reviewincomingapplications/selectors';

import * as DuplicateAppsActions from '../state/duplicateapps/actions';
import { IncomingApplicationReasonEnum } from './Constants';
import 'Styles/pages/reviewincomingapplications/reviewincomingapplications.less';
import {
  deleteIncomingApplication,
  deleteIncomingMember,
  setIncomingStudentAsMember,
  saveIncomingApplicationAsNew,
} from '../state/grid/actions';
import { ReviewDuplicatesModal } from './ReviewDuplicatesModal';
import { getReasonText } from '../helpers/index';

const Modals = {
  ReviewDuplicatesModal: 'showReviewDuplicatesModal',
};

class ReviewAppGridContainer extends Component {
  constructor(props) {
    super(props);

    if (!_.isNil(props.savedGridState)) {
      this.state = { ...props.savedGridState };
    } else {
      this.state = {
        expanded: {},
        showDeleteConfirm: false,
        deletingRowId: null,
        [Modals.ReviewDuplicatesModal]: false,
        scannedAppId: null,
      };
    }
  }

  columns = () => {
    return [
      {
        Header: 'Last Name',
        accessor: 'HouseholdLastName',
      },
      {
        Header: 'First Name',
        accessor: 'HouseholdFirstName',
      },
      {
        Header: 'Address 1',
        accessor: 'HouseholdAddress1',
      },
      {
        Header: 'Address 2',
        accessor: 'HouseholdAddress2',
      },
      {
        Header: 'City',
        accessor: 'City',
      },
      {
        Header: 'State',
        accessor: 'State',
        width: 40,
      },
      {
        Header: 'Zip Code',
        accessor: 'Zip',
        width: 65,
      },
      {
        Header: 'Source',
        id: 'Source',
        width: 65,
        accessor: (row) => (row.LAPId == null ? 'Scanned' : 'LAP'),
      },
      {
        Header: 'Application Date',
        accessor: 'ApplicationDate',
        minWidth: 165,
        sortMethod: dateSortMethod,
      },
      {
        Header: 'Ready',
        id: 'Ready',
        width: 45,
        filterable: false,
        accessor: (row) =>
          row.Members.findIndex((member) => member.ReasonId !== null) === -1 ? (
            <Icon
              name="check"
              style={{ color: 'green' }}
              title="This application is ready to be saved."
            />
          ) : (
            <Icon
              name="warning sign"
              style={{ color: 'orange' }}
              title="There are outstanding issues with this application before it can be saved."
            />
          ),
      },
      {
        Header: '',
        id: 'Cog',
        filterable: false,
        sortable: false,
        style: { textAlign: 'center' },
        width: 40,
        Cell: (row) =>
          GridContextMenu({ gridProps: row, options: this.cogOptions(row) }),
      },
    ];
  };

  subColumns = (members) => {
    return [
      {
        Header: ' ',
        width: 35,
      },
      {
        Header: 'Student Number',
        accessor: 'MemberStudentNumber',
      },
      {
        Header: 'Last Name',
        accessor: 'MemberLastName',
      },
      {
        Header: 'First Name',
        accessor: 'MemberFirstName',
      },
      {
        Header: 'Site',
        accessor: 'MemberSchoolNumber',
      },
      {
        Header: 'Birth Date',
        id: 'Birth Date',
        accessor: (row) => defaultDateFormat(row.BirthDateDT),
      },
      {
        Header: 'Reason',
        Id: 'Reason',
        accessor: 'Reason',
        Cell: (row) => {
          const {
            original: { ReasonId },
          } = row;
          return getReasonText(ReasonId);
        },
      },
      {
        Header: '',
        id: 'Cog',
        filterable: false,
        sortable: false,
        style: { textAlign: 'center' },
        width: 40,
        Cell: (row) =>
          GridContextMenu({
            gridProps: row,
            options: this.subCogOptions(row.original, members),
          }),
      },
    ];
  };

  cogOptions = (row) => {
    let options = [];
    let members = row.original.Members;

    if (row.original.Id) {
      const hasDuplicate = members.some(
        (m) => m.ReasonId === IncomingApplicationReasonEnum.Duplicate
      );

      if (hasDuplicate) {
        options.push({
          icon: 'tasks',
          text: 'View All Apps',
          handler: () => this.onViewAllAppsClick(row.original.Id),
        });
      }
    }

    if (
      members.findIndex(
        (member) =>
          member.ReasonId !== null &&
          member.ReasonId !== IncomingApplicationReasonEnum.Homeless &&
          member.ReasonId !== IncomingApplicationReasonEnum.Migrant &&
          member.ReasonId !== IncomingApplicationReasonEnum.Runaway &&
          member.ReasonId !== IncomingApplicationReasonEnum.CaseNumber
      ) === -1
    ) {
      options.push({
        icon: 'save',
        text: 'Save as New',
        handler: this.onSaveAsNewClick,
      });
    }

    options.push({
      icon: 'delete',
      text: 'Delete Application',
      handler: this.onDeleteApplicationClick,
    });

    return options;
  };

  subCogOptions = (member, members) => {
    let options = [];

    if (members.length > 1) {
      options = options.concat([
        {
          icon: 'user outline',
          text: 'Set as Member',
          handler: this.onSetAsMemberClick,
        },
        {
          icon: 'delete',
          text: 'Delete Student',
          handler: this.onDeleteStudentClick,
        },
      ]);
    }

    if (member.HouseholdSystemId) {
      options = options.concat([
        {
          icon: 'eye',
          text: 'View Duplicate App',
          handler: this.onViewDuplicateAppClick(member.HouseholdSystemId),
        },
      ]);
    }

    options.push({
      icon: 'search',
      text: 'Replace Student',
      handler: this.replaceStudentClick,
    });

    return options;
  };

  replaceStudentClick = (row) => {
    this.props.history.push(
      `/reviewincomingapplications/studentlookup/${row.Id}`
    );
  };

  onSaveAsNewClick = (row) => {
    this.props.saveIncomingApplicationAsNew(row.Id);
  };

  onSetAsMemberClick = (row) => {
    this.props.setIncomingStudentAsMember(row.Id);
  };

  onViewDuplicateAppClick = (id) => () => {
    this.props.history.push(`/manageapplication/${id}?r=ria`);
  };

  onDeleteStudentClick = (row) => {
    this.props.deleteIncomingMember(row.Id);
  };

  onDeleteApplicationClick = (row) => {
    this.setState({ showDeleteConfirm: true, deletingRowId: row.Id });
  };

  onDeleteApplication = () => {
    var rowId = this.state.deletingRowId;
    this.setState({ showDeleteConfirm: false, deletingRowId: null });

    if (!rowId) {
      return;
    }
    this.props.deleteIncomingApplication(rowId);
    this.setState({ expanded: {} });
  };

  onViewAllAppsClick = (appId) => {
    const { getDuplicateApplications } = this.props;
    this.setModalState(Modals.ReviewDuplicatesModal, true);
    this.setState({ scannedAppId: appId });
    getDuplicateApplications(appId);
  };

  renderSubGrid = (row) => {
    return (
      <Fragment>
        <ReactTable
          className={'review-incoming-applications-sub-grid'}
          data={row.original.Members}
          columns={this.subColumns(row.original.Members)}
          minRows={1}
          showPagination={false}
          filterable={false}
          sortable={false}
          noDataText={'No members found'}
          resizable={false}
          getTheadTrProps={() => ({
            className: 'review-incoming-applications-sub-grid-header',
          })}
        />
      </Fragment>
    );
  };

  setModalState = (modal, show) => {
    this.setState({ [modal]: show });
  };

  getState = () => {
    return this.state;
  };

  render() {
    const { history } = this.props;
    const {
      [Modals.ReviewDuplicatesModal]: showReviewDuplicatesModal,
      scannedAppId,
    } = this.state;

    return (
      <Fragment>
        <ReactTableWrapper
          saveState={{
            tableName: TableNamesEnum.REVIEW_INCOMING_APPLICATIONS_TABLE,
          }}
          menu={'hasCogs'}
          loading={this.props.fetching}
          data={this.props.data}
          columns={this.columns()}
          SubComponent={this.renderSubGrid}
          filterable={true}
          resizable={false}
          defaultFilterMethod={caseInsensitiveFilter}
          expanded={this.state.expanded}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                // The column with the caret to expand has no id (and is the only column with no id)
                if (column.id === undefined) {
                  if (this.state.expanded[rowInfo.viewIndex]) {
                    this.setState({ expanded: {} });
                  } else {
                    this.setState({
                      expanded: { [rowInfo.viewIndex]: true },
                    });
                  }
                }
              },
            };
          }}
          onPageChange={() => this.setState({ expanded: {} })}
        />
        <YesNoDialog
          title={'Delete Application?'}
          showDialog={this.state.showDeleteConfirm}
          question={
            'Are you sure you want to delete this application? This action cannot be undone.'
          }
          yesCallback={this.onDeleteApplication}
          noCallback={() =>
            this.setState({ showDeleteConfirm: false, deletingRowId: null })
          }
        />
        {showReviewDuplicatesModal && (
          <ReviewDuplicatesModal
            open={showReviewDuplicatesModal}
            onClose={() =>
              this.setModalState(Modals.ReviewDuplicatesModal, false)
            }
            size="fullscreen"
            closeOnDimmerClick={false}
            history={history}
            closeIcon={true}
            scannedAppId={scannedAppId}
            getState={this.getState}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  savedGridState: RIAStateCacheSelectors.getSavedReviewAppGridState(state),
});

const mapDispatchToProps = {
  deleteIncomingApplication,
  deleteIncomingMember,
  setIncomingStudentAsMember,
  saveIncomingApplicationAsNew,
  getDuplicateApplications: DuplicateAppsActions.getDuplicateApplications,
};

export const ReviewAppGrid = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReviewAppGridContainer)
);



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/components/ReviewAppGrid.js